import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { MatTableDataSource } from "@angular/material/table";
import { ApiService } from "src/app/services/api.service";
import { ChangeContactStatusModalComponent } from "../change-contact-status-modal/change-contact-status-modal.component";
import { MatDialog } from "@angular/material/dialog";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "fury-contact-table",
  templateUrl: "./contact-table.component.html",
  styleUrls: ["./contact-table.component.scss"],
})
export class ContactTableComponent implements OnInit {
  ngUnSubscribe = new Subject<void>();
  @Input() columns: any[];
  @Input() itemList: any;
  @Input() dataSource: MatTableDataSource<any>;
  @Output() search = new EventEmitter<any>();
  @Input() tabIndex: any;
  @Input() isLoading = false;
  @Input() searchForm: FormGroup;
  @Output() fetchContact = new EventEmitter<any>();
  constructor(public apiService: ApiService, private dialog: MatDialog) {}

  ngOnInit(): void {}

  get visibleColumns() {
    return this.columns
      .filter((column) => column.visible)
      .map((column) => column.property);
  }
  searchData() {
    if (this.isLoading) return;
    this.search.emit(this.searchForm.value);
  }

  OpenChangeStatusModal(data: any) {
    if (data?.status === "Completed") return;
    this.dialog
      .open(ChangeContactStatusModalComponent, {
        data: data,
        width: "600px",
      })
      .afterClosed()
      .pipe(takeUntil(this.ngUnSubscribe))
      .subscribe((res: any) => {
        if (res) {
          this.fetchContact.emit(res);
        }
      });
  }

  ngOnDestroy() {
    this.ngUnSubscribe.next();
    this.ngUnSubscribe.complete();
  }
}
